
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {

    // 获取纪念馆追忆文章列表
    GetMemorialArticleMemorialArticleSearch({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemorialArticle/MemorialArticleSearch',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 获取深情感文集合
    getMemorialArticleList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/DeepArticle/GetMemorialArticleList',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 获取追忆文章内容详细
    getMemorialArticleDetailed({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemorialArticle/MemorialArticleDetailed',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 给追忆文章点赞  articleId  文章Id
    addFacePraise({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MemorialArticle/AddFacePraise',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 添加追忆文章
    MemorialArticleMemorialArticleAddVue({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MemorialArticle/MemorialArticleAddVue',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    // 删除追忆文章
    DelMemorialArticleVue({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/MemorialArticle/DelMemorialArticleVue',payload, res => {                
                resolve(res.Result);
            }, err => {
                reject(err);
            })
        })
    },
    
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
